import React from 'react'
import './hero.css'
import three from '../../images/three.svg'
import six from '../../images/six.svg'
import illustration from '../../images/illustration.svg'

const Hero = () => {
  return (
    <section className='hero' id='hero'>
      <div className="hero-container container">
        <div className="hero-wrapper">
            <div className="hero-left">
                <div className="hero-header header">
                    A web developer from another planet!
                    <img src={three} alt="three" id='three' className='bg'/>
                </div>
                <div className="hero-details">
                    I'm a full stack web developer who turns your ideas into websites!
                </div> 
                <div className="call">
                <a href="#about" className='link'>
                  <div className='button'>About me</div>
                </a>

                <a href="#work" className='link'>
                  <div className='button primary-button'>My work</div>
                </a>
                </div>
            </div>
            <div className="hero-right">
                <img src={illustration} alt="illustration" className='illustration'/>
            </div>
        </div>
            <img src={six} alt="six" id='six' className='bg'/>
      </div>
    </section>
  )
}

export default Hero
